import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-light text-center text-lg-start mt-auto">
      <div className="container p-3">
        <div className="row">
          <div className="col-12 col-md-4 mb-3 mb-md-0 text-md-start">
            {/* Пример простого названия сайта или логотипа */}
            <h5>ToGoWith</h5>
          </div>

          <div className="col-12 col-md-8 text-md-end">
            {/* Ссылки на поддержку, условия использования и политику */}
            <Link to="/support" className="text-decoration-none me-3">
              Support
            </Link>
            <Link to="/terms" className="text-decoration-none me-3">
              Terms of Use
            </Link>
            <Link to="/privacy" className="text-decoration-none">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
      <div className="text-center p-2 bg-light border-top">
        {/* Пояснение или копирайт */}
        <small className="text-muted">
          © 2025 ToGoWith. All rights reserved.
        </small>
      </div>
    </footer>
  );
};

export default Footer;
